module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_006#_idTextAnchor017"
    }
  }, [_vm._v("Introduction"), _c('span', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("Raise your hand if you spend too much time in the grocery store staring at the wall of pastas, condiments, and cooking oils wondering which ones are the best. This cookbook is for you. It contains all my shopping knowledge along with over fifty epic recipes that use the best ingredients and products from the grocery store. Grocery shopping and cooking are my two big passions in life. If you follow me @flavcity on social media, you know this. So I thought it would be fun to not only teach you how to cook really easy and tasty meals using five ingredients, but also how to navigate the grocery store and choose the best items to "), _c('span', [_vm._v("cook")]), _c('span'), _c('span', [_vm._v("with.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("It amazes me how much garbage is out there! I mean, seriously—have you read the ingredients on some of these products? And how many of them are in your pantry and fridge right now? I’m going to school you on every single aisle in the grocery store and help you locate the major ingredient offenders to stay away from. Spoiler alert! These ingredients are in the majority of items from the middle aisles of the store. You’re also going to learn how to take some truly amazing products that have best-in-class ingredients and make super easy and healthy recipes at home. These recipes are easy enough that anyone can make them. Yes, everyone. That was the reason I wanted to write this book. I believe the key to overall health is cooking your own meals and knowing exactly what goes into your body, along with a few workouts per week; if you do that, nothing can"), _c('span', [_vm._v(" stop")]), _c('span'), _c('span', [_vm._v("you!")])]), _vm._v(" "), _c('p', {
    staticClass: "body_body"
  }, [_vm._v("I really think this book is one of a kind, combining expert shopping tips that I have learned while making hundreds of grocery haul videos on the "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("FlavCity")]), _vm._v(" YouTube channel along with recipes that have monster flavor with minimal ingredients a"), _c('span', [_vm._v("nd")]), _c('span'), _c('span', [_vm._v("effort.")])]), _vm._v(" "), _c('p', {
    staticClass: "body_instruction-next-para",
    attrs: {
      "id": "calibre_pb_15"
    }
  }, [_vm._v("We just launched the Bobby Approved app. I highly suggest giving it a try. It has all of my shopping knowledge, a detailed breakdown of every aisle in the store, and a bar code scanner that tells you if a product is Bobby Approved. Search for the app in the App Store and Google P"), _c('span', [_vm._v("lay")]), _c('span'), _c('span', [_vm._v("Store.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e98e455","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_008.vue
// module id = 81
// module chunks = 0